import styled from "styled-components";
import { ParcelCol, ParcelRow } from "styles/parcelsStyles";

export const ContainersListRow = styled(ParcelRow)`
  /* match Storage shipment row height (logo + checkbox-area padding) */
  min-height: 70px;
`;

export const ContainerCol = styled(ParcelCol)`
  text-align: left;
  line-height: 20px;
  white-space: nowrap;

  ${(props) => props.theme.lg`
    white-space: normal;
  `}

  ${(props) => props.theme.md`
    white-space: nowrap;
  `}
`;

export const Sku = styled.div`
  color: ${({ theme }) => theme.accentText};
`;

export const WeightText = styled.span`
  && {
    color: ${({ theme }) => theme.rowMetaText};
  }
`;

export const ParcelDate = styled.div`
  color: ${({ theme }) => theme.rowMetaText};
`;
